import React, { HTMLAttributes } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';

import { wacToken } from '@/libraries/design/foundations/index.ts';

// <thead> wrapper — bottom border only, matching pricing table
const theadCss = css({
	borderBlockEnd: `solid 1px ${wacToken('color.neutral.light400')}`,
	[media.below.sm]: {
		display: 'none',
	},
	background: wacToken('color.neutral.light0'),
});

export interface GenericTableTheadProps extends HTMLAttributes<HTMLTableSectionElement> {
	colWidth?: string;
}

export const GenericTableThead = ({ colWidth, style, ...props }: GenericTableTheadProps) => {
	return (
		<thead
			{...props}
			css={theadCss}
			style={
				{
					'--generic-table-col-width': colWidth,
					...style,
				} as React.CSSProperties
			}
		/>
	);
};

// Column header <tr>
const headRowCss = css({});

export const GenericTableHeadRow = (props: HTMLAttributes<HTMLTableRowElement>) => {
	return <tr {...props} css={headRowCss} />;
};

// Section header <tr> — matches pricing table SectionHeader atom
const sectionHeaderRowCss = css({
	color: wacToken('color.primary.black'),
	backgroundColor: wacToken('color.neutral.light100'),
	transition: 'background-color .5s',
	padding: 0,
	textAlign: 'center',
	[media.below.sm]: {
		display: 'none',
	},
});

export const GenericTableSectionHeaderRow = (props: HTMLAttributes<HTMLTableRowElement>) => {
	return <tr {...props} css={sectionHeaderRowCss} />;
};

export interface GenericTableSectionHeaderCellProps extends HTMLAttributes<HTMLTableCellElement> {
	colSpan?: number;
}

const sectionHeaderCellCss = css({
	justifyContent: 'space-between',
	fontWeight: 400,
	textAlign: 'left',
	color: wacToken('color.primary.black'),
	[media.below.sm]: {
		display: 'flex',
		padding: '12px 14px',
	},
	display: 'table-cell',
	padding: '14px',
	borderInlineEnd: `1px solid ${wacToken('color.neutral.light400')}`,
	':last-of-type': {
		borderInlineEnd: 'none',
	},
});

const sectionHeaderTextCss = css({
	color: wacToken('color.primary.black'),
	width: '100%',
	fontWeight: 'bold',
	height: 'auto',
	display: 'block',
	overflowWrap: 'break-word',
});

export const GenericTableSectionHeaderCell = ({
	colSpan = 999,
	children,
	...props
}: GenericTableSectionHeaderCellProps) => {
	return (
		<th {...props} css={sectionHeaderCellCss} colSpan={colSpan} scope="rowgroup">
			<span css={sectionHeaderTextCss}>{children}</span>
		</th>
	);
};
